// import React, { useState, useEffect } from 'react';
// import PropTypes from 'prop-types';
// import { Save, X, Plus, Trash2 } from 'lucide-react';
// import './CreateUpdateSuite.css';
// const emptyForm = {
//   name: '',
//   description: '',
//   basePrice: '',
//   capacity: '',
//   size: '',
//   totalRooms: '',
//   images: [],
//   amenities: []
// };

// const CreateUpdateSuite = ({
//   initialData = null,
//   onSubmit,
//   onCancel,
//   isLoading = false
// }) => {
//   const isEditMode = !!initialData;

//   const [formData, setFormData] = useState(emptyForm);
//   const [newImage, setNewImage] = useState('');
//   const [newAmenity, setNewAmenity] = useState('');

//   useEffect(() => {
//     if (initialData) {
//       setFormData({
//         name: initialData.name || '',
//         description: initialData.description || '',
//         basePrice: initialData.basePrice || '',
//         capacity: initialData.capacity || '',
//         size: initialData.size || '',
//         totalRooms: initialData.totalRooms || '',
//         images: initialData.images || [],
//         amenities: initialData.amenities || []
//       });
//     } else {
//       setFormData(emptyForm);
//     }
//     console.log(setFormData.images)
//     setNewImage('');
//     setNewAmenity('');
//   }, [initialData]);
// //Remove
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]:
//         name === 'basePrice' || name === 'capacity' || name === 'totalRooms'
//           ? value === '' ? '' : Number(value)
//           : value
//     }));
//   };

//   const addImage = () => {
//     if (!newImage.trim()) return;

//     setFormData((prev) => ({
//       ...prev,
//       images: [...prev.images, newImage.trim()]
//     }));
//     setNewImage('');
//   };

//   const removeImage = (index) => {
//     setFormData((prev) => ({
//       ...prev,
//       images: prev.images.filter((_, i) => i !== index)
//     }));
//   };

//   const addAmenity = () => {
//     if (!newAmenity.trim()) return;

//     setFormData((prev) => ({
//       ...prev,
//       amenities: [...prev.amenities, newAmenity.trim()]
//     }));
//     setNewAmenity('');
//   };

//   const removeAmenity = (index) => {
//     setFormData((prev) => ({
//       ...prev,
//       amenities: prev.amenities.filter((_, i) => i !== index)
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     await onSubmit(formData);

//     if (!isEditMode) {
//       setFormData(emptyForm);
//       setNewImage('');
//       setNewAmenity('');
//     }
//   };

//   return (
//     <div className="suite-container">
//       <div className="suite-header">
//         <h2>{isEditMode ? 'Update Suite Type' : 'Create New Suite Type'}</h2>
//         <p>
//           {isEditMode
//             ? 'Modify suite information and settings'
//             : 'Add a new suite type to your hotel'}
//         </p>
//       </div>

//       <form onSubmit={handleSubmit} className="suite-form-wrapper">
//         <div className="suite-form">
//           <input
//             type="text"
//             name="name"
//             value={formData.name}
//             onChange={handleChange}
//             required
//             placeholder="Suite Name"
//           />

//           <input
//             type="text"
//             name="size"
//             value={formData.size}
//             onChange={handleChange}
//             required
//             placeholder="Size (e.g. 85 sqm)"
//           />

//           <input
//             type="number"
//             name="basePrice"
//             value={formData.basePrice}
//             onChange={handleChange}
//             required
//             placeholder="Base Price"
//           />

//           <input
//             type="number"
//             name="capacity"
//             value={formData.capacity}
//             onChange={handleChange}
//             required
//             min="1"
//             placeholder="Capacity"
//           />

//           <input
//             type="number"
//             name="totalRooms"
//             value={formData.totalRooms}
//             onChange={handleChange}
//             required
//             min="1"
//             placeholder="Total Rooms"
//           />
//         </div>

//         <div className="suite-section">
//           <label>Description</label>
//           <textarea
//             name="description"
//             value={formData.description}
//             onChange={handleChange}
//             required
//             rows={4}
//             placeholder="Describe this suite type..."
//             className="suite-textarea"
//           />
//         </div>

//         <div className="suite-section">
//           <label>Images</label>
//           <div className="suite-inline-group">
//             <input
//               type="text"
//               value={newImage}
//               onChange={(e) => setNewImage(e.target.value)}
//               placeholder="Enter image URL"
//             />
//             <button type="button" onClick={addImage} className="small-btn">
//               <Plus size={18} /> Add
//             </button>
//           </div>

//           <div className="suite-list">
//             {formData.images.map((img, index) => (
//               <div key={index} className="suite-card">
//                 <img src={img} alt={`Suite ${index + 1}`} className="suite-image" />
//                 <button type="button" onClick={() => removeImage(index)}>
//                   <Trash2 size={16} /> Remove
//                 </button>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="suite-section">
//           <label>Amenities</label>
//           <div className="suite-inline-group">
//             <input
//               type="text"
//               value={newAmenity}
//               onChange={(e) => setNewAmenity(e.target.value)}
//               placeholder="Add amenity"
//             />
//             <button type="button" onClick={addAmenity} className="small-btn">
//               <Plus size={18} /> Add
//             </button>
//           </div>

//           <div className="amenities-list">
//             {formData.amenities.map((amenity, index) => (
//               <div key={index} className="amenity-tag">
//                 <span>{amenity}</span>
//                 <button type="button" onClick={() => removeAmenity(index)}>
//                   <X size={14} />
//                 </button>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="suite-actions">
//           {isEditMode && (
//             <button
//               type="button"
//               onClick={onCancel}
//               className="cancel-btn"
//               disabled={isLoading}
//             >
//               Cancel Edit
//             </button>
//           )}

//           <button type="submit" disabled={isLoading}>
//             <Save size={18} />
//             {isLoading
//               ? isEditMode
//                 ? 'Updating...'
//                 : 'Creating...'
//               : isEditMode
//               ? 'Update Suite'
//               : 'Create Suite'}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// CreateUpdateSuite.propTypes = {
//   initialData: PropTypes.object,
//   onSubmit: PropTypes.func.isRequired,
//   onCancel: PropTypes.func.isRequired,
//   isLoading: PropTypes.bool
// };

// export default CreateUpdateSuite;









import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Save, X, Plus, Trash2 } from 'lucide-react';
import './CreateUpdateSuite.css';

const emptyForm = {
  name: '',
  description: '',
  basePrice: '',
  capacity: '',
  size: '',
  totalRooms: '',
  images: [],
  amenities: []
};

const CreateUpdateSuite = ({
  initialData = null,
  onSubmit,
  onCancel,
  isLoading = false
}) => {
  const isEditMode = !!initialData;

  const [formData, setFormData] = useState(emptyForm);
  const [newImage, setNewImage] = useState('');
  const [newAmenity, setNewAmenity] = useState('');

  // Fix: Properly set form data when editing
  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || '',
        description: initialData.description || '',
        basePrice: initialData.basePrice || '',
        capacity: initialData.capacity || '',
        size: initialData.size || '',
        totalRooms: initialData.totalRooms || '',
        images: Array.isArray(initialData.images) ? initialData.images : [],
        amenities: Array.isArray(initialData.amenities) ? initialData.amenities : []
      });
    } else {
      setFormData(emptyForm);
    }
    setNewImage('');
    setNewAmenity('');
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        name === 'basePrice' || name === 'capacity' || name === 'totalRooms'
          ? value === '' ? '' : Number(value)
          : value
    }));
  };

  const addImage = () => {
    if (!newImage.trim()) return;
    setFormData((prev) => ({
      ...prev,
      images: [...prev.images, newImage.trim()]
    }));
    setNewImage('');
  };

  const removeImage = (index) => {
    setFormData((prev) => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index)
    }));
  };

  const addAmenity = () => {
    if (!newAmenity.trim()) return;
    setFormData((prev) => ({
      ...prev,
      amenities: [...prev.amenities, newAmenity.trim()]
    }));
    setNewAmenity('');
  };

  const removeAmenity = (index) => {
    setFormData((prev) => ({
      ...prev,
      amenities: prev.amenities.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  // Helper function to fix image URL
  const getImageUrl = (imgPath) => {
    if (!imgPath) return '';
    
    // If it's already a full URL (http/https), use it directly
    if (imgPath.startsWith('http')) {
      return imgPath;
    }

    // Fix relative paths starting with /Images/
    if (imgPath.startsWith('/Images/')) {
      return `https://apitop.topranohotelandlounge.com${imgPath}`;
    }

    // If it starts with Images/ without leading slash
    if (imgPath.startsWith('Images/')) {
      return `https://apitop.topranohotelandlounge.com/${imgPath}`;
    }

    // Fallback: assume it's relative to backend
    return `https://apitop.topranohotelandlounge.com${imgPath.startsWith('/') ? '' : '/'}${imgPath}`;
  };

  return (
    <div className="suite-container">
      <div className="suite-header">
        <h2>{isEditMode ? 'Update Suite Type' : 'Create New Suite Type'}</h2>
        <p>
          {isEditMode
            ? 'Modify suite information and settings'
            : 'Add a new suite type to your hotel'}
        </p>
      </div>

      <form onSubmit={handleSubmit} className="suite-form-wrapper">
        <div className="suite-form">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Suite Name"
          />

          <input
            type="text"
            name="size"
            value={formData.size}
            onChange={handleChange}
            required
            placeholder="Size (e.g. 85 sqm)"
          />

          <input
            type="number"
            name="basePrice"
            value={formData.basePrice}
            onChange={handleChange}
            required
            placeholder="Base Price"
          />

          <input
            type="number"
            name="capacity"
            value={formData.capacity}
            onChange={handleChange}
            required
            min="1"
            placeholder="Capacity"
          />

          <input
            type="number"
            name="totalRooms"
            value={formData.totalRooms}
            onChange={handleChange}
            required
            min="1"
            placeholder="Total Rooms"
          />
        </div>

        <div className="suite-section">
          <label>Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
            rows={4}
            placeholder="Describe this suite type..."
            className="suite-textarea"
          />
        </div>

        {/* ==================== IMAGES SECTION ==================== */}
        <div className="suite-section">
          <label>Images</label>
          <div className="suite-inline-group">
            <input
              type="text"
              value={newImage}
              onChange={(e) => setNewImage(e.target.value)}
              placeholder="Enter image URL (e.g. /Images/ROOM6.jpg)"
            />
            <button type="button" onClick={addImage} className="small-btn">
              <Plus size={18} /> Add
            </button>
          </div>

          <div className="suite-list">
            {formData.images.length === 0 ? (
              <p className="no-images">No images added yet</p>
            ) : (
              formData.images.map((img, index) => (
                <div key={index} className="suite-card">
                  <img 
                    src={getImageUrl(img)} 
                    alt={`Suite ${index + 1}`} 
                    className="suite-image"
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/300x200?text=Image+Not+Found';
                    }}
                  />
                  <button 
                    type="button" 
                    onClick={() => removeImage(index)}
                    className="remove-btn"
                  >
                    <Trash2 size={16} /> Remove
                  </button>
                </div>
              ))
            )}
          </div>
        </div>

        {/* ==================== AMENITIES SECTION ==================== */}
        <div className="suite-section">
          <label>Amenities</label>
          <div className="suite-inline-group">
            <input
              type="text"
              value={newAmenity}
              onChange={(e) => setNewAmenity(e.target.value)}
              placeholder="Add amenity (e.g. King Bed)"
            />
            <button type="button" onClick={addAmenity} className="small-btn">
              <Plus size={18} /> Add
            </button>
          </div>

          <div className="amenities-list">
            {formData.amenities.map((amenity, index) => (
              <div key={index} className="amenity-tag">
                <span>{amenity}</span>
                <button type="button" onClick={() => removeAmenity(index)}>
                  <X size={14} />
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="suite-actions">
          <button
            type="button"
            onClick={onCancel}
            className="cancel-btn"
            disabled={isLoading}
          >
            Cancel
          </button>

          <button type="submit" disabled={isLoading} className="submit-btn">
            <Save size={18} />
            {isLoading
              ? (isEditMode ? 'Updating...' : 'Creating...')
              : (isEditMode ? 'Update Suite' : 'Create Suite')}
          </button>
        </div>
      </form>
    </div>
  );
};

CreateUpdateSuite.propTypes = {
  initialData: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};

export default CreateUpdateSuite;